import { Header } from "@/components/header";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";

export const Route = createRootRoute({
  validateSearch: (search: { preview?: string } | undefined) => search ?? {},
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Header />
      <Outlet />
      <Toaster />
    </>
  );
}
